import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=77e727d7&scoped=true"
import script from "./PersonEdit.vue?vue&type=script&lang=js"
export * from "./PersonEdit.vue?vue&type=script&lang=js"
import style0 from "./PersonEdit.vue?vue&type=style&index=0&id=77e727d7&prod&lang=scss&scoped=true"
import style1 from "./PersonEdit.vue?vue&type=style&index=1&id=77e727d7&prod&lang=scss&scoped=true"
import style2 from "./PersonEdit.vue?vue&type=style&index=2&id=77e727d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e727d7",
  null
  
)

export default component.exports